"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_meta_tags_1 = __importDefault(require("react-meta-tags"));
var constants_1 = require("../../shared/constants");
var globals_service_1 = __importDefault(require("../../services/globals.service"));
function Meta(_a) {
    var author = _a.author, title = _a.title, description = _a.description, keywords = _a.keywords, canonical = _a.canonical, imagePath = _a.imagePath;
    if (globals_service_1.default.firstRender)
        return null;
    return (react_1.default.createElement(react_meta_tags_1.default, null,
        react_1.default.createElement("title", null, title),
        react_1.default.createElement("meta", { name: "title", content: title }),
        react_1.default.createElement("meta", { name: "description", content: description }),
        react_1.default.createElement("meta", { name: "keywords", content: keywords }),
        react_1.default.createElement("meta", { name: "author", content: author }),
        react_1.default.createElement("meta", { itemProp: "name", content: title }),
        react_1.default.createElement("meta", { itemProp: "description", content: description }),
        react_1.default.createElement("meta", { itemProp: "image", content: imagePath }),
        react_1.default.createElement("meta", { property: "og:title", content: title }),
        react_1.default.createElement("meta", { property: "og:description", content: description }),
        react_1.default.createElement("meta", { property: "og:image", content: imagePath }),
        react_1.default.createElement("meta", { property: "og:url", content: "".concat(constants_1.serverRootUrl).concat(canonical) }),
        react_1.default.createElement("link", { rel: "canonical", href: "".concat(constants_1.serverRootUrl).concat(canonical) })));
}
exports.default = Meta;
